import '../base.js';
import Glide from '@glidejs/glide'

new Glide('.glide', {
  autoplay: 5000,
  hoverpause: true,
  type: 'carousel',
}).mount()
